import styled from 'styled-components/macro';

export const Option = styled.option`
  font-weight: 500;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.font};
`;
